import React from 'react';
import { required } from 'react-admin';
import EditSelectInput from '../../../../customFields/EditSelectInput';
import EditField from '../../../../customFields/EditField';
import currencies from '../../../../constants/currencies';
import paymentDetailsMethodChoices from '../constants/paymentDetailsMethodChoices';

const InvoiceProductInformation = ({
  showEdit,
}: {
  showEdit: boolean;
}) => (
  <>
    <EditField
      source="productInformation.invoiceDate"
      type="date"
      label="invoice date"
      showEdit={showEdit}
      validate={required()}
    />
    <EditField
      source="productInformation.dueDate"
      type="date"
      label="due date"
      showEdit={showEdit}
      validate={required()}
    />
    <EditSelectInput
      source="productInformation.currency"
      label="Currency"
      choices={currencies.map((currency) => ({
        id: currency,
        name: currency,
      }))}
      showEdit={showEdit}
      validate={required()}
    />
    <EditField
      source="productInformation.invoiceAmount"
      type="number"
      label="Invoice amount"
      showEdit={showEdit}
      validate={required()}
    />
    <EditField
      source="productInformation.vatAmount"
      type="number"
      label="VAT amount"
      showEdit={showEdit}
    />
    <EditField
      source="productInformation.invoiceNumber"
      label="Invoice Number"
      showEdit={showEdit}
    />
    <EditField
      source="productInformation.customerNumber"
      label="Customer Number"
      showEdit={showEdit}
    />
    <EditField
      source="productInformation.paymentDetails.accountNumber"
      label="Payment account number"
      showEdit={showEdit}
    />
    <EditField
      source="productInformation.paymentDetails.reference"
      label="Payment reference"
      showEdit={showEdit}
    />
    <EditSelectInput
      source="productInformation.paymentDetails.method"
      label="Payment method"
      choices={paymentDetailsMethodChoices}
      showEdit={showEdit}
    />
  </>
);

export default InvoiceProductInformation;
